import {domain} from './../config';

export const getData = (state) => state[domain].data;
export const getUi = (state) => state[domain].ui;